import { render, staticRenderFns } from "./switch_modal.vue?vue&type=template&id=0e3d97ea&scoped=true"
import script from "./switch_modal.vue?vue&type=script&lang=js"
export * from "./switch_modal.vue?vue&type=script&lang=js"
import style0 from "./switch_modal.vue?vue&type=style&index=0&id=0e3d97ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3d97ea",
  null
  
)

export default component.exports